/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PlanScope {
    SHARED = 'SHARED',
    CONNECTION_SPECIFIC = 'CONNECTION_SPECIFIC',
}
